import React from 'react';
import { cn } from '../../../lib/utils';
import { CheckTick } from '../../../components/icons';

interface SubItemProps {
  selected: boolean;
  onClick: () => void;
  label: string;
}

export function SubItem({ selected, onClick, label }: SubItemProps): React.ReactElement {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        'w-full text-left bg-white rounded-lg px-3.5 py-3 border-2 transition-colors flex items-center justify-between text-[14px] mb-1.5',
        selected ? 'border-ink font-medium text-ink' : 'border-stroke text-ink hover:border-helper'
      )}
    >
      <span>{label}</span>
      <CheckTick className={cn('w-[18px] h-[18px]', selected ? 'text-brand' : 'text-transparent')} />
    </button>
  );
}
